export const SKILLS = [
  // Tier 1 — 2pts
  { id: 'web_search',    name: 'Web Search',     emoji: '🔍', description: 'Search the web for current information',          tier: 1, cost: 2, category: 'research' },
  { id: 'read_file',     name: 'Read File',      emoji: '📄', description: 'Read and parse documents and files',              tier: 1, cost: 2, category: 'analysis' },
  { id: 'write_note',    name: 'Write Note',     emoji: '📝', description: 'Write and save notes and summaries',              tier: 1, cost: 2, category: 'writing' },
  { id: 'send_message',  name: 'Send Message',   emoji: '💬', description: 'Send messages to teammates or contacts',          tier: 1, cost: 2, category: 'comms' },

  // Tier 2 — 4pts
  { id: 'deep_research', name: 'Deep Research',  emoji: '🧠', description: 'Multi-source deep research on any topic',         tier: 2, cost: 4, category: 'research' },
  { id: 'code_execute',  name: 'Code Execute',   emoji: '💻', description: 'Write and run code to solve problems',            tier: 2, cost: 4, category: 'technical' },
  { id: 'data_analysis', name: 'Data Analysis',  emoji: '📊', description: 'Analyze datasets and generate insights',          tier: 2, cost: 4, category: 'analysis' },
  { id: 'draft_document',name: 'Draft Document', emoji: '📋', description: 'Draft long-form documents and reports',           tier: 2, cost: 4, category: 'writing' },

  // Tier 3 — 6pts
  { id: 'autonomous_browse', name: 'Auto Browse',    emoji: '🌐', description: 'Browse and interact with websites autonomously', tier: 3, cost: 6, category: 'research' },
  { id: 'memory_store',     name: 'Memory Store',   emoji: '🗂️', description: 'Store and retrieve long-term memories',          tier: 3, cost: 6, category: 'intelligence' },
  { id: 'agent_delegate',   name: 'Agent Delegate', emoji: '🤝', description: 'Delegate subtasks to other agents',              tier: 3, cost: 6, category: 'comms' },
  { id: 'api_call',         name: 'API Call',       emoji: '⚡', description: 'Make calls to external APIs and services',        tier: 3, cost: 6, category: 'technical' },

  // Tier 4 — 10pts
  { id: 'full_autonomy', name: 'Full Autonomy',  emoji: '🚀', description: 'Execute complex multi-step tasks independently',  tier: 4, cost: 10, category: 'intelligence' },
  { id: 'multi_agent',   name: 'Multi-Agent',    emoji: '👥', description: 'Orchestrate multiple agents on a single task',     tier: 4, cost: 10, category: 'intelligence' },
];

export const SKILL_POINT_BUDGET = 20;

export const TIER_COLORS = {
  1: { border: '#4a4a4a', glow: '#666', label: 'Basic' },
  2: { border: '#2d6a3f', glow: '#4ade80', label: 'Standard' },
  3: { border: '#1e3a6e', glow: '#60a5fa', label: 'Advanced' },
  4: { border: '#6b3a1e', glow: '#f59e0b', label: 'Legendary' },
};

export function getPointsUsed(agent) {
  return (agent.equippedSkills || []).reduce((sum, skillId) => {
    const skill = SKILLS.find((s) => s.id === skillId);
    return sum + (skill?.cost || 0);
  }, 0);
}
